export const footerMoreLinks = {
  'kw-ar': [
    {
      title: 'أكثر',
      items: [
        {
          href: 'https://kw.wingie.com/contact/',
          title: 'التواصل',
        },
        {
          href: 'https://kw.wingie.com/faq/',
          title: 'الأسئلة المتكررة',
        },
        {
          href: 'https://kw.wingie.com/about-us/',
          title: 'تعرّف علينا',
        },
        {
          href: 'https://kw.wingie.com/privacy/',
          title: 'الخصوصية - وينجي',
        },
        {
          href: 'https://kw.wingie.com/terms-and-conditions/',
          title: 'شروط الاستخدام',
        },
        {
          href: 'https://kw.wingie.com/awards/',
          title: 'جوائزنا',
        },
      ],
    },
  ],
  'kw-en': [
    {
      title: 'More',
      items: [
        {
          href: 'https://kw.wingie.com/en/contact/',
          title: 'Contact',
        },
        {
          href: 'https://kw.wingie.com/en/faq/',
          title: 'Frequently Asked Questions',
        },
        {
          href: 'https://kw.wingie.com/en/about-us/',
          title: 'About us',
        },
        {
          href: 'https://kw.wingie.com/en/privacy/',
          title: 'Privacy',
        },
        {
          href: 'https://kw.wingie.com/en/terms-and-conditions/',
          title: 'Terms and Conditions',
        },
        {
          href: 'https://kw.wingie.com/en/awards/',
          title: 'Our Awards',
        },
      ],
    },
  ],
  'kw-es': [
    {
      title: 'Más',
      items: [
        {
          href: 'https://kw.wingie.com/es/contacto/',
          title: 'Contacto',
        },
        {
          href: 'https://kw.wingie.com/es/preguntas-frecuentes/',
          title: 'Preguntas más frecuentes',
        },
        {
          href: 'https://kw.wingie.com/es/acerca-de-nosotros/',
          title: 'Sobre nosotros',
        },
        {
          href: 'https://kw.wingie.com/es/privacidad/',
          title: 'Privacidad',
        },
        {
          href: 'https://kw.wingie.com/es/terminos-y-condiciones/',
          title: 'Términos y condiciones de uso',
        },
        {
          href: 'https://kw.wingie.com/es/awards/',
          title: 'Nuestros premios',
        },
      ],
    },
  ],
  'kw-de': [
    {
      title: 'Mehr',
      items: [
        {
          href: 'https://kw.wingie.com/de/kontakt/',
          title: 'Kontakt',
        },
        {
          href: 'https://kw.wingie.com/de/faq/',
          title: 'Häufig gestellte Fragen - Wingie',
        },
        {
          href: 'https://kw.wingie.com/de/uber-uns/',
          title: 'Über uns',
        },
        {
          href: 'https://kw.wingie.com/de/datenschutz/',
          title: 'Datenschutz & Cookies',
        },
        {
          href: 'https://kw.wingie.com/de/allgemeine-geschaeftsbedingungen/',
          title: 'Allgemeine Geschäftsbedingungen',
        },
        {
          href: 'https://kw.wingie.com/de/awards/',
          title: 'Unsere Auszeichnungen',
        },
      ],
    },
  ],
  'kw-ru': [
    {
      title: 'более',
      items: [
        {
          href: 'https://kw.wingie.com/ru/contact/',
          title: 'Контакты',
        },
        {
          href: 'https://kw.wingie.com/ru/faq/',
          title: 'Часто задаваемые вопросы',
        },
        {
          href: 'https://kw.wingie.com/ru/about-us/',
          title: 'О нас',
        },
        {
          href: 'https://kw.wingie.com/ru/privacy/',
          title: 'Конфиденциальность',
        },
        {
          href: 'https://kw.wingie.com/ru/terms-and-conditions/',
          title: 'Условия и положения',
        },
        {
          href: 'https://kw.wingie.com/ru/awards/',
          title: 'Наши награды',
        },
      ],
    },
  ],
  'kw-it': [
    {
      title: 'Altro',
      items: [
        {
          href: 'https://kw.wingie.com/it/contact/',
          title: 'Contatto',
        },
        // {
        //     href: 'https://kw.wingie.com/it/faq/',
        //     title: 'Domande Frequenti',
        // },
        {
          href: 'https://kw.wingie.com/it/about-us/',
          title: 'Chi siamo',
        },
        {
          href: 'https://kw.wingie.com/it/privacy/',
          title: 'Privacy',
        },
        {
          href: 'https://kw.wingie.com/it/terms-and-conditions/',
          title: 'Termini e Condizioni',
        },
        {
          href: 'https://kw.wingie.com/it/awards/',
          title: 'I nostri premi',
        },
      ],
    },
  ],
  'kw-fr': [
    {
      title: 'Plus',
      items: [
        {
          href: 'https://kw.wingie.com/fr/contact/',
          title: 'Contact',
        },
        // {
        //     href: 'https://kw.wingie.com/fr/faq/',
        //     title: 'Questions Fréquemment Posées',
        // },
        {
          href: 'https://kw.wingie.com/fr/about-us/',
          title: 'À propos de nous',
        },
        {
          href: 'https://kw.wingie.com/fr/privacy/',
          title: 'Confidentialité',
        },
        {
          href: 'https://kw.wingie.com/fr/terms-and-conditions/',
          title: 'Termes et Conditions',
        },
        {
          href: 'https://kw.wingie.com/fr/awards/',
          title: 'Nos Prix',
        },
      ],
    },
  ],
  'kw-pt': [
    {
      title: 'Mais',
      items: [
        {
          href: 'https://kw.wingie.com/pt/contact/',
          title: 'Contacto',
        },
        // {
        //     href: 'https://kw.wingie.com/pt/faq/',
        //     title: 'Perguntas Frequentes',
        // },
        {
          href: 'https://kw.wingie.com/pt/about-us/',
          title: 'Sobre nós',
        },
        {
          href: 'https://kw.wingie.com/pt/privacy/',
          title: 'Privacidade',
        },
        {
          href: 'https://kw.wingie.com/pt/terms-and-conditions/',
          title: 'Termos e Condições',
        },
        {
          href: 'https://kw.wingie.com/pt/awards/',
          title: 'Os nossos prémios',
        },
      ],
    },
  ],
  'kw-ro': [
    {
      title: 'Mai Mult',
      items: [
        {
          href: 'https://kw.wingie.com/ro/contact/',
          title: 'Contact',
        },
        // {
        //     href: 'https://kw.wingie.com/ro/faq/',
        //     title: 'Întrebări Frecvente',
        // },
        {
          href: 'https://kw.wingie.com/ro/about-us/',
          title: 'Despre noi',
        },
        {
          href: 'https://kw.wingie.com/ro/privacy/',
          title: 'Confidențialitate',
        },
        {
          href: 'https://kw.wingie.com/ro/terms-and-conditions/',
          title: 'Termeni și Condiții',
        },
        {
          href: 'https://kw.wingie.com/ro/awards/',
          title: 'Premiile noastre',
        },
      ],
    },
  ],
  'kw-pl': [
    {
      title: 'Więcej',
      items: [
        {
          href: 'https://kw.wingie.com/pl/contact/',
          title: 'Kontakt',
        },
        // {
        //     href: 'https://kw.wingie.com/pl/faq/',
        //     title: 'Często Zadawane Pytania',
        // },
        {
          href: 'https://kw.wingie.com/pl/about-us/',
          title: 'O nas',
        },
        {
          href: 'https://kw.wingie.com/pl/privacy/',
          title: 'Prywatność',
        },
        {
          href: 'https://kw.wingie.com/pl/terms-and-conditions/',
          title: 'Regulamin',
        },
        {
          href: 'https://kw.wingie.com/pl/awards/',
          title: 'Nasze nagrody',
        },
      ],
    },
  ],
  'kw-lt': [
    {
      title: 'Daugiau',
      items: [
        {
          href: 'https://kw.wingie.com/lt/contact/',
          title: 'Kontaktai',
        },
        // {
        //     href: 'https://kw.wingie.com/lt/faq/',
        //     title: 'Dažnai Užduodami Klausimai',
        // },
        {
          href: 'https://kw.wingie.com/lt/about-us/',
          title: 'Apie mus',
        },
        {
          href: 'https://kw.wingie.com/lt/privacy/',
          title: 'Privatumas',
        },
        {
          href: 'https://kw.wingie.com/lt/terms-and-conditions/',
          title: 'Taisyklės ir Sąlygos',
        },
        {
          href: 'https://kw.wingie.com/lt/awards/',
          title: 'Mūsų apdovanojimai',
        },
      ],
    },
  ],
  'kw-uz': [
    {
      title: "Ko'proq",
      items: [
        {
          href: 'https://kw.wingie.com/uz/contact/',
          title: 'Aloqa',
        },
        // {
        //     href: 'https://kw.wingie.com/uz/faq/',
        //     title: 'Tez-tez Beriladigan Savollar',
        // },
        {
          href: 'https://kw.wingie.com/uz/about-us/',
          title: 'Biz haqimizda',
        },
        {
          href: 'https://kw.wingie.com/uz/privacy/',
          title: 'Maxfiylik',
        },
        {
          href: 'https://kw.wingie.com/uz/terms-and-conditions/',
          title: 'Shartlar va Qoidalar',
        },
        {
          href: 'https://kw.wingie.com/uz/awards/',
          title: 'Bizning mukofotlarimiz',
        },
      ],
    },
  ],
  'kw-sr': [
    {
      title: 'Више',
      items: [
        {
          href: 'https://kw.wingie.com/sr/contact/',
          title: 'Контакт',
        },
        // {
        //     href: 'https://kw.wingie.com/sr/faq/',
        //     title: 'Честа питања',
        // },
        {
          href: 'https://kw.wingie.com/sr/about-us/',
          title: 'О нама',
        },
        {
          href: 'https://kw.wingie.com/sr/privacy/',
          title: 'Приватност',
        },
        {
          href: 'https://kw.wingie.com/sr/terms-and-conditions/',
          title: 'Услови коришћења',
        },
        {
          href: 'https://kw.wingie.com/sr/awards/',
          title: 'Наше награде',
        },
      ],
    },
  ],
  'kw-ky': [
    {
      title: 'Дагы',
      items: [
        {
          href: 'https://kw.wingie.com/ky/contact/',
          title: 'Байланыш',
        },
        // {
        //     href: 'https://kw.wingie.com/ky/faq/',
        //     title: 'Жыйнак суроолор',
        // },
        {
          href: 'https://kw.wingie.com/ky/about-us/',
          title: 'Биз жөнүндө',
        },
        {
          href: 'https://kw.wingie.com/ky/privacy/',
          title: 'Купуялуулук',
        },
        {
          href: 'https://kw.wingie.com/ky/terms-and-conditions/',
          title: 'Шарттар жана Талаптар',
        },
        {
          href: 'https://kw.wingie.com/ky/awards/',
          title: 'Биздин сыйлыктар',
        },
      ],
    },
  ],
  'kw-tg': [
    {
      title: 'Бештар',
      items: [
        {
          href: 'https://kw.wingie.com/tg/contact/',
          title: 'Тамос',
        },
        // {
        //     href: 'https://kw.wingie.com/tg/faq/',
        //     title: 'Саволҳои зиёд',
        // },
        {
          href: 'https://kw.wingie.com/tg/about-us/',
          title: 'Дар бораи мо',
        },
        {
          href: 'https://kw.wingie.com/tg/privacy/',
          title: 'Махфият',
        },
        {
          href: 'https://kw.wingie.com/tg/terms-and-conditions/',
          title: 'Шартҳо ва шароитҳо',
        },
        {
          href: 'https://kw.wingie.com/tg/awards/',
          title: 'Ҷоизаҳои мо',
        },
      ],
    },
  ],
  'kw-kk': [
    {
      title: 'Көбірек',
      items: [
        {
          href: 'https://kw.wingie.com/kk/contact/',
          title: 'Байланыс',
        },
        {
          href: 'https://kw.wingie.com/kk/faq/',
          title: 'Жиі қойылатын сұрақтар',
        },
        // {
        //     href: 'https://kw.wingie.com/kk/faq/',
        //     title: 'Жиі қойылатын сұрақтар',
        // },
        {
          href: 'https://kw.wingie.com/kk/about-us/',
          title: 'Біз туралы',
        },
        {
          href: 'https://kw.wingie.com/kk/privacy/',
          title: 'Құпиялылық',
        },
        {
          href: 'https://kw.wingie.com/kk/terms-and-conditions/',
          title: 'Шарттар мен ережелер',
        },
        {
          href: 'https://kw.wingie.com/kk/awards/',
          title: 'Біздің марапаттарымыз',
        },
      ],
    },
  ],
  'kw-nl': [
    {
      title: 'Meer',
      items: [
        {
          href: 'https://kw.wingie.com/nl/contact/',
          title: 'Contact',
        },
        // {
        //     href: 'https://kw.wingie.com/nl/faq/',
        //     title: 'Veelgestelde Vragen',
        // },
        {
          href: 'https://kw.wingie.com/nl/about-us/',
          title: 'Over ons',
        },
        {
          href: 'https://kw.wingie.com/nl/privacy/',
          title: 'Privacy',
        },
        {
          href: 'https://kw.wingie.com/nl/terms-and-conditions/',
          title: 'Voorwaarden',
        },
        {
          href: 'https://kw.wingie.com/nl/awards/',
          title: 'Onze prijzen',
        },
      ],
    },
  ],
  'kw-ja': [
    {
      title: 'もっと',
      items: [
        { title: 'お問い合わせ', href: 'https://kw.wingie.com/ja/contact/' },
        { title: 'よくある質問', href: 'https://kw.wingie.com/en/faq/' },
        { title: '会社概要', href: 'https://kw.wingie.com/ja/about-us/' },
        { title: 'プライバシーポリシー', href: 'https://kw.wingie.com/ja/privacy/' },
        { title: '利用規約', href: 'https://kw.wingie.com/ja/terms-and-conditions/' },
        { title: '受賞歴', href: 'https://kw.wingie.com/ja/awards/' },
      ],
    },
  ],
  'kw-zh': [
    {
      title: '更多',
      items: [
        { title: '联系方式', href: 'https://kw.wingie.com/zh/contact/' },
        { title: '常见问题', href: 'https://kw.wingie.com/en/faq/' },
        { title: '关于我们', href: 'https://kw.wingie.com/zh/about-us/' },
        { title: '隐私政策', href: 'https://kw.wingie.com/zh/privacy/' },
        { title: '条款和条件', href: 'https://kw.wingie.com/zh/terms-and-conditions/' },
        { title: '我们的奖项', href: 'https://kw.wingie.com/zh/awards/' },
      ],
    },
  ],
  'kw-ko': [
    {
      title: '더보기',
      items: [
        { title: '연락처', href: 'https://kw.wingie.com/ko/contact/' },
        { title: '자주 묻는 질문', href: 'https://kw.wingie.com/en/faq/' },
        { title: '회사 소개', href: 'https://kw.wingie.com/ko/about-us/' },
        { title: '개인정보처리방침', href: 'https://kw.wingie.com/ko/privacy/' },
        { title: '이용약관', href: 'https://kw.wingie.com/ko/terms-and-conditions/' },
        { title: '수상 내역', href: 'https://kw.wingie.com/ko/awards/' },
      ],
    },
  ],
  'kw-hi': [
    {
      title: 'अधिक',
      items: [
        { title: 'संपर्क करें', href: 'https://kw.wingie.com/hi/contact/' },
        { title: 'सामान्य प्रश्न', href: 'https://kw.wingie.com/en/faq/' },
        { title: 'हमारे बारे में', href: 'https://kw.wingie.com/hi/about-us/' },
        { title: 'गोपनीयता', href: 'https://kw.wingie.com/hi/privacy/' },
        { title: 'नियम और शर्तें', href: 'https://kw.wingie.com/hi/terms-and-conditions/' },
        { title: 'हमारे पुरस्कार', href: 'https://kw.wingie.com/hi/awards/' },
      ],
    },
  ],
  'kw-ta': [
    {
      title: 'மேலும்',
      items: [
        { title: 'தொடர்பு', href: 'https://kw.wingie.com/ta/contact/' },
        { title: 'அடிக்கடி கேட்கப்படும் கேள்விகள்', href: 'https://kw.wingie.com/en/faq/' },
        { title: 'எங்கள் பற்றி', href: 'https://kw.wingie.com/ta/about-us/' },
        { title: 'தனியுரிமை', href: 'https://kw.wingie.com/ta/privacy/' },
        { title: 'விதிமுறைகள்', href: 'https://kw.wingie.com/ta/terms-and-conditions/' },
        { title: 'எங்கள் விருதுகள்', href: 'https://kw.wingie.com/ta/awards/' },
      ],
    },
  ],
  'kw-th': [
    {
      title: 'เพิ่มเติม',
      items: [
        { title: 'ติดต่อเรา', href: 'https://kw.wingie.com/th/contact/' },
        { title: 'คำถามที่พบบ่อย', href: 'https://kw.wingie.com/en/faq/' },
        { title: 'เกี่ยวกับเรา', href: 'https://kw.wingie.com/th/about-us/' },
        { title: 'นโยบายความเป็นส่วนตัว', href: 'https://kw.wingie.com/th/privacy/' },
        { title: 'ข้อกำหนดและเงื่อนไข', href: 'https://kw.wingie.com/th/terms-and-conditions/' },
        { title: 'รางวัลของเรา', href: 'https://kw.wingie.com/th/awards/' },
      ],
    },
  ],
  'kw-ur': [
    {
      title: 'مزید',
      items: [
        { title: 'رابطہ کریں', href: 'https://kw.wingie.com/ur/contact/' },
        { title: 'عمومی سوالات', href: 'https://kw.wingie.com/en/faq/' },
        { title: 'ہمارے بارے میں', href: 'https://kw.wingie.com/ur/about-us/' },
        { title: 'رازداری', href: 'https://kw.wingie.com/ur/privacy/' },
        { title: 'شرائط و ضوابط', href: 'https://kw.wingie.com/ur/terms-and-conditions/' },
        { title: 'ہمارے اعزازات', href: 'https://kw.wingie.com/ur/awards/' },
      ],
    },
  ],
  'kw-ka': [
    {
      title: 'მეტი',
      items: [
        { title: 'კონტაქტი', href: 'https://kw.wingie.com/ka/contact/' },
        { title: 'ხშირად დასმული კითხვები', href: 'https://kw.wingie.com/en/faq/' },
        { title: 'ჩვენ შესახებ', href: 'https://kw.wingie.com/ka/about-us/' },
        { title: 'კონფიდენციალურობა', href: 'https://kw.wingie.com/ka/privacy/' },
        { title: 'წესები და პირობები', href: 'https://kw.wingie.com/ka/terms-and-conditions/' },
        { title: 'ჩვენი ჯილდოები', href: 'https://kw.wingie.com/ka/awards/' },
      ],
    },
  ],
}
